import React from "react"
import PropTypes from "prop-types"
import Radium, { keyframes } from "higher-order-components/configured-radium/"
import COLOR_PALETTE from "constants/color-palette"
import { CrossIcon } from "components"
import AnimatedArrowIcon from "./animated-arrow-icon"
import { breakpointTablet } from "../settings"

const TopNavigationItem = ({
  label, open, onClick, CloseIcon = null, Icon = null, badge
}) => (
  <div
    style={[
      styles.wrapper,
      open && { background: COLOR_PALETTE.GRAY3, color: COLOR_PALETTE.WHITE }
    ]}>
    <div style={styles.line} />
    <div style={styles.base} onClick={onClick}>
      <span style={styles.showOnCompact}>
        {/* Force remount with key to trigger animation */}
        <div key={open ? "open" : "closed"} style={styles.closeIconAnimation}>
          {open ? <CrossIcon style={styles.icon} /> : <Icon style={styles.icon} />}
        </div>
        {!open && badge > 0 && <span style={styles.badge}>{badge}</span>}
      </span>
      <span style={styles.showOnDesktop}>
        <Icon style={styles.icon} />
        {badge > 0 && <span style={styles.badge}>{badge}</span>}
      </span>
      <span style={styles.extendedInfo}>
        {label} <AnimatedArrowIcon flip={open} />
      </span>
    </div>
  </div>
)

const fadeInKeyframes = keyframes({
  from: {
    opacity: 0,
    transform: "translateZ(1px) translateY(-10%)"
  }
})

const styles = {
  closeIconAnimation: {
    // add translateZ to fix position fixed glitches in IOS - https://stackoverflow.com/questions/20832531/mobile-safari-positionfixed-z-index-glitch-when-scrolling
    transform: "translateZ(1px)",
    animation: "x .25s",
    animationName: fadeInKeyframes
  },
  showOnDesktop: {
    display: "none",
    [breakpointTablet]: {
      display: "block",
      position: "relative"
    }
  },
  showOnCompact: {
    display: "block",
    position: "relative",
    [breakpointTablet]: {
      display: "none"
    }
  },
  wrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    transition: "background 0.66s, color .666s",
    width: "4.5rem",
    color: COLOR_PALETTE.GRAY_DARK,
    [breakpointTablet]: {
      width: "auto",
      ":hover": {
        color: COLOR_PALETTE.WHITE
      }
    }
  },
  base: {
    cursor: "pointer",
    height: "100%",
    fontWeight: 600,
    letterSpacing: "0.08em",
    display: "flex",
    alignItems: "center",
    padding: "0 1.5em"
  },
  line: {
    margin: "1em 0",
    borderLeft: "1px solid #474747",
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    [breakpointTablet]: {
      display: "none",
      borderLeft: "none"
    }
  },
  extendedInfo: {
    whiteSpace: "nowrap",
    paddingLeft: "0.5em",
    display: "none",
    [breakpointTablet]: {
      display: "block"
    }
  },
  icon: {
    fill: "currentColor",
    height: "1em",
    width: "1em",
    verticalAlign: "text-top"
  },
  badge: {
    display: "inline-block",
    position: "absolute",
    color: COLOR_PALETTE.WHITE,
    top: "-4px",
    right: "-4px",
    height: "12px",
    padding: "0 4px",
    borderRadius: "6px",
    fontSize: "10px",
    background: COLOR_PALETTE.RED,
    textAlign: "center",
    lineHeight: "13px",
    zIndex: "9"
  }
}

TopNavigationItem.propTypes = {
  label: PropTypes.string,
  open: PropTypes.bool,
  onClick: PropTypes.func,
  CloseIcon: PropTypes.node,
  Icon: PropTypes.func,
  badge: PropTypes.number
}

export default Radium(TopNavigationItem)



// WEBPACK FOOTER //
// ./src/containers/mymazda/navigation/top-navigation-item.jsx